import React from 'react';
import { Navigate } from 'react-router-dom';
import AuthLoadingScreen from '../components/AuthLoadingScreen/AuthLoadingScreen';
import { useAuth } from '../state/AuthContext';
import { getRootRedirect } from './routingContract';

export default function RootRedirect() {
  const { loading, session } = useAuth();

  if (loading) return <AuthLoadingScreen />;

  return <Navigate to={getRootRedirect(Boolean(session))} replace />;
}
